import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiFooter(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiFooter',
    baseStyle: {
      color: theme.colors.muted,
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: theme.sizes[0]
    }
  };
}
